import { getAuthAxiosBackend } from "../../helpers/axios"

class EmployeeServices{

    get(id){
        return getAuthAxiosBackend().get('housing-units/employees/'+id.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('housing-units/employees', {params: data})
    }

    delete(id){
        return getAuthAxiosBackend().delete('housing-units/employees/' + id)
    }
}

export default new EmployeeServices()